import { api_host, api_auth } from '../../common/globals/constants';

export const getEventsSchedules = (user, objetivo_id, fecha_inicio, fecha_termino, token, schedule) =>
    fetch(api_host + `/reporte/online/eventosHorarios/Reporte3EventsSchedules/?user=${user}&key=${api_auth}&objetive=${objetivo_id}&horarioId=${schedule}&datebegin=${fecha_inicio}&finaldate=${fecha_termino}&hash=3276bd408a114308ab00c6133fe29fb2&token=${token}`)
    .then(response => response.json())